import styled from "@emotion/styled";

export const StyledContainer = styled.div`
  .emotion-UnstyledButton-root {
    border-radius: 4px;
    font-weight: 500;
    font-size: 12px;
  }
`;
